import CardModifierComponent from '../../../../Component/Level/CardModifier';
import Container from '../../../Container';

export default class CardModifier extends Container {
    protected onCreate(params: any): void {
        this.addComponent<CardModifierComponent>(CardModifierComponent, params);
    }
}
